module.exports = __webpack_public_path__ + "media/images/lb/367-65ee3b6c3b8a22ecd4418515d705c873.svg";